// extracted by mini-css-extract-plugin
export default {"messageCardContainer":"MessageCard_messageCardContainer__y1CuU","imgContainer":"MessageCard_imgContainer__Vj3nL"};